import { Controller } from "stimulus"

// The setup wizard's podcasts step: rows of title / subdomain / description that can be added to, and a
// subdomain that follows the title until the creator edits it themselves.
export default class extends Controller {
  static targets = ["rows", "template"]

  add() {
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
  }

  suggest(event) {
    const subdomain = event.target.closest("[data-podcast-row]").querySelector("[data-podcast-subdomain]")
    if (subdomain.dataset.edited === "true") return

    subdomain.value = this.slugify(event.target.value)
  }

  edited(event) {
    event.target.dataset.edited = "true"
  }

  slugify(text) {
    return text
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 63)
  }
}
